module.exports = __webpack_public_path__ + "img/karolina.cbb01f67.jpg";